import { render, staticRenderFns } from "./MarineLayer.vue?vue&type=template&id=495606b7&"
import script from "./MarineLayer.vue?vue&type=script&lang=ts&"
export * from "./MarineLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports